import type { SubmissionAttempt } from "./submission.ts";

const UNDER = "rally-draft:";
const ATTEMPT_UNDER = "rally-draft-attempt:";
const CONTEXT_UNDER = "rally-draft-context:";

function store(): Storage | null {
  try {
    return typeof sessionStorage === "undefined" ? null : sessionStorage;
  } catch {
    return null;
  }
}

export function draftFor(conversation: string): string {
  try {
    return store()?.getItem(UNDER + conversation) ?? "";
  } catch {
    return "";
  }
}

export function keepDraft(conversation: string, text: string): void {
  try {
    if (text === "") store()?.removeItem(UNDER + conversation);
    else store()?.setItem(UNDER + conversation, text);
  } catch {}
}

export function attemptForDraft(shelf: string): SubmissionAttempt | null {
  try {
    const raw = store()?.getItem(ATTEMPT_UNDER + shelf);
    if (!raw) return null;
    const held = JSON.parse(raw) as Partial<SubmissionAttempt>;
    return typeof held.signature === "string" && typeof held.id === "string"
      ? { signature: held.signature, id: held.id }
      : null;
  } catch {
    return null;
  }
}

export function keepDraftAttempt(shelf: string, attempt: SubmissionAttempt): void {
  try {
    store()?.setItem(ATTEMPT_UNDER + shelf, JSON.stringify(attempt));
  } catch {}
}

export function forgetDraftAttempt(shelf: string): void {
  try {
    store()?.removeItem(ATTEMPT_UNDER + shelf);
  } catch {}
}

export function draftContextFor(shelf: string): unknown {
  try {
    const raw = store()?.getItem(CONTEXT_UNDER + shelf);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function keepDraftContext(shelf: string, context: unknown | null): void {
  try {
    if (context === null) store()?.removeItem(CONTEXT_UNDER + shelf);
    else store()?.setItem(CONTEXT_UNDER + shelf, JSON.stringify(context));
  } catch {}
}

export function forgetDraft(conversation: string): void {
  keepDraft(conversation, "");
  forgetDraftAttempt(conversation);
}

export function forgetEveryDraft(): void {
  const held = store();
  if (!held) return;
  try {
    const keys: string[] = [];
    for (let at = 0; at < held.length; at += 1) {
      const key = held.key(at);
      if (key?.startsWith(UNDER) || key?.startsWith(ATTEMPT_UNDER) || key?.startsWith(CONTEXT_UNDER)) {
        keys.push(key);
      }
    }
    for (const key of keys) held.removeItem(key);
  } catch {}
}
